import queryString from 'query-string';

export const getStringifiedParams = (params: Record<string, any>): string => {
  return queryString.stringify({ ...params }, { skipNull: true });
};

export const getBaseURL = (): string => {
  return window.location.origin;
};